<template>
  <div class="confim-card">
    <div class="confim-card-body hotel-card-component lg:flex lg:space-x-8 relative" @click="$emit('open-dialog', hotel)"
        :class="{ 'hoverable cursor-pointer' : !onlyInfo}">
      <div class="img-container">
        <img v-if="hotel.images" :src="`http://photos.hotelbeds.com/giata/${hotel.images[0].path}`" />
        <img v-else :src="`${hotel.image}`" />
      </div>
      <div class="details-container block w-full my-1 lg:my-0 lg:w-2/3 lg:self-center"
          :class="{ 'lg:grid lg:grid-cols-2' : !onlyInfo }">
        <div class="block">
          <tripadvisor-score
            v-if="hotel.reviews"
            :rating="hotel.reviews[0].rate"
          ></tripadvisor-score>
          <div :class="{'block' : !onlyInfo, 'flex' : onlyInfo }">
            <div class="items-center mr-1 my-1 lg:my-4">
              <p class="name font-bold mr-3">{{ hotel.name }}</p>
            </div>
            <hotel-category
              class="grow-0 my-1 lg:my-4"
              :category-code="hotel.categoryCode"
              :style="{ minWidth: hotelCategoryMinWidth(hotel.categoryCode) }"
            ></hotel-category>
          </div>
          <div class="flex space-x-2 my-3 lg:my-4">
            <div class="icon-container">
              <img src="/img/icons/maps-and-flags.svg" />
            </div>
            <span class="text-gray-600 font-semibold">{{ hotel.distance }} km del centro</span>
          </div>
          <div v-for="(room, index) in rooms" :key="index" class="flex space-x-2 my-4">
            <div class="block">
              <div class="num-rooms text-sm w-6 h-6 bg-pale-grey font-black text-center rounded-sm text-black opacity-100">
                <!-- x{{ room.rates[0].rooms }} -->
                x1
              </div>
            </div>
            <div class="block">
              <span>{{ room.name | capitalize }}</span><br/>
            </div>
            <!-- <span>{{ $t("hotel.double_standard") }}</span> -->
          </div>
          <!-- <div v-if="rate.boardCode == 'BB'" class="board-tag">
            <span class="capitalize">Desayno incluido</span>
          </div> -->
        </div>
        <div class="block lg:text-right mt-auto" v-if="!onlyInfo">
          <div class="leading-tight text-2xl font-bold text-black">
            {{ hotel.price | currency_no_space }}
          </div>
          <div class="flex lg:block">
            <div class="font-bold lg:mt-1 text-gray-600">
              {{ nights }} {{ nights > 1 ? "noches" : "noche" }} {{$t('shared.in')}}
              {{ destination }}
            </div>
            <div class="mx-1 lg:hidden">·</div>
            <div class="font-bold lg:mt-1 text-gray-600">
              {{ adults }} {{ adults > 1 ? "adultos" : "adulto" }}
            </div>
          </div>
          <div class="hidden lg:block">
            <v-btn
              @click.stop="select(hotel)"
              rounded
              color="secondary"
              class="ml-auto mt-2 avm-btn min-width-custom block self-center font-bold"
              :class="{ disabled: loading }"
              :loading="loading"
            >
              {{$t('shared.select')}}
            </v-btn>
            <v-btn
              @click="$emit('open-dialog', hotel)"
              rounded
              class="ml-auto mt-2 avm-btn min-width-custom block self-center font-bold outline-btn"
              :class="{ disabled: loading }"
              :loading="loading"
            >
              {{$t('shared.details')}}
            </v-btn>
          </div>
          <div class="flex lg:hidden">
            <v-btn
              @click="$emit('open-dialog', hotel)"
              rounded
              class="lg:ml-auto mx-auto mt-2 avm-btn min-width-custom block self-center font-bold outline-btn"
              :class="{ disabled: loading }"
              :loading="loading"
            >
            {{$t('shared.details')}}
            </v-btn>
            <v-btn
              @click.stop="select(hotel)"
              rounded
              color="secondary"
              class="lg:ml-auto mx-auto mt-2 avm-btn min-width-custom block self-center font-bold"
              :class="{ disabled: loading }"
              :loading="loading"
            >
              {{$t('shared.select')}}
            </v-btn>
          </div>
        </div>
        <div v-else>
          <div class="flex">
            <div class="font-bold lg:mt-1 text-gray-600">
              {{ nights }} {{ nights > 1 ? "noches" : "noche" }} en
              {{ destination }}
            </div>
            <div class="mx-1 text-2xl">· </div>
            <div class="font-bold lg:mt-1 text-gray-600">
              {{ adults }} {{ adults > 1 ? "adultos" : "adulto" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="onlyInfo" class="confim-card-footer border-top">
      <p>{{ $t('wizard_more_days.accommodation_price') }}:</p>
      <p>{{ hotel.price | currency }}</p>
    </div>
  </div>
</template>

<script>
import HotelCategory from "../common/HotelCategory.vue";
import TripadvisorScore from "./TripadvisorScore.vue";
import { NIGHTS_SET_HOTEL } from "../../../store/nights/mutation-types";
import { goToStep } from "../mixins";
import { mapGetters } from "vuex";
import { NIGHTS_GET_NIGHTS } from "../../../store/nights/getter-types";

export default {
  mixins: [goToStep],
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    onlyInfo: {
      type: Boolean,
      required: true,
    },
    adults: {
      type: Number
    },
    nights: {
      type: Number
    },
    destination: {
      type: String
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  components: {
    HotelCategory,
    TripadvisorScore,
  },
  computed: {
    loading() {
      return (
        this.$store.state.nights.loading &&
        this.$store.state.nights.hotel.code === this.hotel.code
      );
    },
    rooms(){
      let arr = [];
      this.hotel.rooms.forEach(room => {
        arr.push(room);
      });
      return arr;
    }
  },
  methods: {
    hotelCategoryMinWidth(categoryCode) {
      const stars = Number(categoryCode.replace(/(LUX)|(EST)/, ""));
      return `${stars * 25}px`;
    },
    select(hotel) {
      this.$store.commit(NIGHTS_SET_HOTEL, hotel);
      this.goToStep("extras");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.hotel-card-component {
  border-radius: 15px;
  padding: 1.25rem;
  background-color: white;

  .hoverable:hover {
    -webkit-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
  }

  @media (min-width: 768px) {
    padding: 2rem 1.5rem;
  }

  &.selected {
    border: 2px solid $turquoiseBlue;
    background-color: #f7fcfc;
  }

  + .hotel {
    margin-top: 1.5rem;
  }

  .img-container {
    width: 100%;
    height: auto;
    border-radius: 5px;

    @media (min-width: 768px) {
      width: 243px;
      height: 198px;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }

  .details-container {
    margin-top: 1.5rem;

    @media (min-width: 1024px) {
      margin-top: 0;
    }

    > div {
      + div {
        margin-top: 0.85rem;
      }
    }

    .name {
      font-size: 16px;

      @media (min-width: 1024px) {
        font-size: 20px;
      }
    }

    .icon-container {
      width: 1.25rem;
      padding-bottom: .25rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .price {
      font-size: 16px;
      margin-bottom: 0.15rem;

      @media (min-width: 1024px) {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .nights {
      color: $turquoiseBlue;
    }

    .outline-btn {
      &.disabled {
        pointer-events: none;
      }
    }

    .num-rooms{
      padding: .15rem 0;
    }
  }

  .board-tag {
    position: absolute;
    right: 0;
    top: 13px;
    padding: 5px 10px;
    background: #00aa6c;
    color: white;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  &::v-deep {
    .tripadvisor-score-component {
      margin-top: 1rem;

      @media (min-width: 1024px) {
        margin-top: 0;
      }
    }
  }

}

.confim-card-footer {
  background-color: #f3f3f3;
  padding: 0.5rem 2rem;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    max-width: 27px;
  }
  &.border-top {
    border-top: 0.5px solid #9b9b9b;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
}

.avm-btn.min-width-custom {
  @media (max-width: 992px) {
    min-width: 9rem !important;
  }
}
</style>
